

















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapState, mapActions } from "vuex";

// @ is an alias to /src
import LoginForm from "@/components/Auth/LoginForm.vue";

import NavBar from "@/components/Layout/NavBar.vue";
import AsideMenu from "@/components/Layout/AsideMenu.vue";
import { ServerResult } from "./core/http/server_result";
// import FooterBar from '@/components/Layout/FooterBar.vue'

// import { mdiTruckDeliveryOutline } from '@mdi/js';

@Component({
  computed: {
    ...mapState("ubic", ["token", "actor"]),
    ...mapGetters("ubic", ["isAuthenticated"])
  },
  components: {
    LoginForm,
    AsideMenu,
    NavBar
  }
})
export default class App extends Vue {
  public isAuthenticated!: boolean;
  public actor!: any;

  get menu() {
    const _menu: any = [
      "Личное",
      [
        {
          to: { name: "work_plan_board" },
          icon: "contrast-box",
          label: "План/Факт"
        }
      ],
      "Компания",
      [
        {
          to: { name: "employee-list" },
          label: "Сотрудники",
          icon: "account-multiple",
          permissions: [
            "admin",
            "account_manager",
            "sales_head",
            "corporate_sales_manager",
            "regional_sales_manager",
            "logistics_manager",
            "production"
          ]
          // updateMark: true
        },
        {
          to: { name: "department-manager" },
          label: "Структура",
          icon: "domain",
          permissions: [
            "admin",
            "account_manager",
            "sales_head",
            "corporate_sales_manager",
            "regional_sales_manager",
            "logistics_manager"
          ]
        }
      ],
      "Продажи",
      [
        {
          label: "Воронки",
          icon: "filter-variant",
          submenu: "pipelines",
          permissions: [
            "admin",
            "sales_head",
            "corporate_sales_manager",
            "regional_sales_manager",
            "logistics_manager"
          ],
          props: [
            this.pipelines.map((pipeline: any) => {
              return {
                to: { name: "deal-pipelines", params: { id: pipeline.id } },
                label: pipeline.label,
                icon: "table-of-contents"
              };
            })
          ]
        },
        {
          to: { name: "deal-list" },
          label: "Заявки",
          icon: "cart-outline",
          permissions: [
            "admin",
            "account_manager",
            "sales_head",
            "corporate_sales_manager",
            "regional_sales_manager",
            "logistics_manager"
          ]
        },
        {
          to: { name: "clients-list" },
          label: "Контрагенты",
          icon: "book-open-variant",
          permissions: [
            "admin",
            "account_manager",
            "sales_head",
            "corporate_sales_manager",
            "regional_sales_manager",
            "logistics_manager"
          ]
        },
        {
          label: "Каталог продуктов",
          submenu: "products",
          icon: "shopping-outline",
          permissions: [
            "admin",
            "account_manager",
            "sales_head",
            "corporate_sales_manager",
            "regional_sales_manager",
            "logistics_manager",
            "catalog",
            "products"
          ],
          props: [
            [
              {
                to: { name: "product-directory" },
                label: "Справочник продуктов",
                icon: "book-open-page-variant",
                permissions: ["admin", "products"]
              },
              {
                to: { name: "product-catalog" },
                label: "Продукты",
                icon: "shopping-outline",
                permissions: [
                  "admin",
                  "account_manager",
                  "sales_head",
                  "corporate_sales_manager",
                  "regional_sales_manager",
                  "logistics_manager",
                  "catalog",
                  "products"
                ]
              },
              {
                to: { name: "prime-costs-list" },
                label: "Себестоимость",
                icon: "cash",
                permissions: ["admin", "catalog", "products"]
              }
            ]
          ]
        }

      ],
      "Склады",
      [
        {
          to: { name: "warehouses-list" },
          label: "Склады",
          icon: "store-outline",
          permissions: ["admin", "sales_head"]
        },
        {
          to: { name: "warehouses-resort-list" },
          label: "Перегруппировка",
          icon: "swap-horizontal-bold",
          permissions: ["admin", "sales_head"]
        }
        // {
        //   to: { name: 'warehouses-delivery-approve-list' },
        //   label: 'Подтверждение доставки',
        //   icon: 'truck-delivery-outline',
        //   permissions: ['admin', 'sales_head']
        // },
      ],
      "Финансы",
      [
        {
          to: { name: "transport-costs-list" },
          label: "Транспорные расходы",
          icon: "cash",
          permissions: ["admin", "logistics_manager"]
        }
      ],

      "Доставка",
      [
        {
          to: { name: "delivery-sheet" },
          label: "Маршрутные листы",
          icon: "truck-delivery-outline",
          permissions: ["admin", "logistics_manager"],
          badge: "countDeliverySheetInit"
        },
        {
          to: { name: "delivery-zones-manager" },
          label: "Управление зонами",
          icon: "map",
          permissions: ["admin", "logistics_manager"]
        },
        {
          to: { name: "delivery-vehicles-manager" },
          label: "Машины и водители",
          icon: "map",
          permissions: ["admin", "logistics_manager"]
        },
        {
          to: { name: "delivery-dates-manager" },
          label: "Даты доставки",
          icon: "calendar",
          permissions: ["admin", "logistics_manager"]
        }
      ],

      "Аналитика",
      [
        {
          to: { name: "shipment-forecast" },
          label: "Прогноз отгрузок",
          icon: "timetable",
          permissions: ["admin", "controller", "sales_head"]
        },
        {
          to: { name: "shipment-forecast-by-container" },
          label: "Прогноз отгрузок по таре",
          icon: "timetable",
          permissions: ["admin", "controller", "sales_head"]
        },
        {
          to: { name: "shipment-forecast-by-date" },
          label: "Прогноз производства",
          icon: "timetable",
          permissions: ["admin", "controller", "sales_head"]
        },
        {
          to: { name: "production-forecast-daily" },
          label: "Планирование производства",
          icon: "calendar-range",
          permissions: ["admin", "controller", "sales_head"]
        },
        {
          label: "Отчеты",
          icon: "table-of-contents",
          submenu: "reports",
          permissions: [
            "admin",
            "controller",
            "account_manager",
            "sales_head",
            "corporate_sales_manager",
            "regional_sales_manager",
            "logistics_manager"
          ],
          props: [
            [
              "Продажи",
              {
                to: { name: "reports-activity" },
                label: "По активности",
                icon: "table-of-contents",
                permissions: ["controller"]
              },
              {
                to: { name: "reports-analize-delivery-points" },
                label: "По анализ точек доставки",
                icon: "table-of-contents",
                permissions: ["admin", "sales_head", "logistics_manager"]
              },
              {
                to: { name: "reports-year-product" },
                label: "По аналитике по годам и продуктам",
                icon: "table-of-contents",
                permissions: ["admin", "sales_head", "logistics_manager"]
              },
              {
                to: { name: "reports-by-driver" },
                label: "По водителям",
                icon: "table-of-contents",
                permissions: ["admin", "sales_head", "logistics_manager"]
              },
              {
                to: { name: "reports-deals" },
                label: "По заявкам с образцами",
                icon: "table-of-contents",
                permissions: ["admin", "sales_head"]
              },
              {
                to: { name: "reports-products" },
                label: "По заявкам с чизкейками",
                icon: "table-of-contents",
                permissions: ["admin", "sales_head"]
              },
              {
                to: { name: "prime-costs-report" },
                label: "По изменению себестоимости",
                icon: "table-of-contents",
                permissions: ["admin", "logistics_manager"]
              },
              {
                to: { name: "reports-marginality" },
                label: "По маржинальности",
                icon: "table-of-contents",
                permissions: [
                  "admin",
                  "account_manager",
                  "sales_head",
                  "corporate_sales_manager",
                  "regional_sales_manager"
                ]
              },
              {
                to: { name: "reports-marginality-by-product" },
                label: "По маржинальности продуктов",
                icon: "table-of-contents",
                permissions: [
                  "admin",
                  "account_manager",
                  "sales_head",
                  "corporate_sales_manager",
                  "regional_sales_manager"
                ]
              },
              {
                to: { name: "reports-substandard" },
                label: "По некондиции",
                icon: "table-of-contents",
                permissions: ["admin", "controller", "sales_head"]
              },
              {
                to: { name: "reports-warehouse-clients" },
                label: "По отгрузке со складов",
                icon: "table-of-contents",
                permissions: ["admin", "sales_head", "logistics_manager"]
              },
              {
                to: { name: "reports-warehouse-movement" },
                label: "По перемещения на склады",
                icon: "table-of-contents",
                permissions: ["admin", "sales_head", "logistics_manager"]
              },
              {
                to: { name: "reports-complaints" },
                label: "По рекламации",
                icon: "table-of-contents",
                permissions: ["admin", "controller", "sales_head"]
              },
              {
                to: { name: "reports-complaints-extend" },
                label: "По рекламации (расширенный)",
                icon: "table-of-contents",
                permissions: ["admin", "controller", "sales_head"]
              },
              {
                to: { name: "reports-transports_costs_by_clients" },
                label: "По транспортным/клиентам",
                icon: "table-of-contents",
                permissions: ["admin", "logistics_manager"]
              },
              {
                to: { name: "transport-expences" },
                label: "По фактическим затратам",
                icon: "table-of-contents",
                permissions: ["admin", "logistics_manager"]
              },
              {
                to: { name: "transport-costs" },
                label: "По транспортным расходам",
                icon: "table-of-contents",
                permissions: ["admin", "logistics_manager"]
              },
              {
                to: { name: "warehouse-by-date" },
                label: "По остаткам на складе",
                icon: "table-of-contents",
                permissions: ["admin", "logistics_manager"]
              },
              {
                to: { name: "warehouse-by-transactions" },
                label: "По движению товаров",
                icon: "table-of-contents",
                permissions: ["admin", "logistics_manager"]
              },
              {
                to: { name: "reports-marginality-by-product-detail" },
                label: "Потребление продуктов по клиентам",
                icon: "table-of-contents",
                permissions: [
                  "admin",
                  "account_manager",
                  "sales_head",
                  "corporate_sales_manager",
                  "regional_sales_manager"
                ]
              }
            ]
          ]
        }
      ],

      "Настройки",
      [
        {
          label: "Cловари",
          icon: "format-list-numbered",
          submenu: "vocabularies",
          permissions: ["admin"],
          props: [
            [
              // 'Общие',
              {
                to: { name: "vocs-cities" },
                label: "Города",
                icon: "table-of-contents",
                permissions: ["admin"]
              },
              {
                to: { name: "vocs-positions" },
                label: "Должности",
                icon: "table-of-contents",
                permissions: ["admin"]
              },
              {
                to: { name: "vocs-todo-types" },
                label: "Типы задач",
                icon: "table-of-contents",
                permissions: ["admin"]
              },
              {
                to: { name: "warehouses-manager" },
                label: "Склады",
                icon: "table-of-contents",
                permissions: ["admin"]
              },
              {
                to: { name: "stickers-manager" },
                label: "Стикеры",
                icon: "table-of-contents",
                permissions: ["admin"]
              },
              {
                to: { name: "free-product-types" },
                label: "Типы бесплатных продуктов",
                icon: "table-of-contents",
                permissions: ["admin"]
              },
              {
                to: { name: "product-price-segments-manager" },
                label: "Ценовые сегменты",
                icon: "table-of-contents",
                permissions: ["admin"]
              },
              {
                to: { name: "product-technologies-manager" },
                label: "Технологии",
                icon: "table-of-contents",
                permissions: ["admin"]
              },
              {
                to: { name: "product-trade-marks-manager" },
                label: "Торговые марки",
                icon: "table-of-contents",
                permissions: ["admin"]
              }
            ]
          ]
        },
        {
          to: { name: "db-sync" },
          label: "Синхронизация БД",
          icon: "sync",
          permissions: ["admin"]
        },
        {
          to: { name: "utils" },
          label: "Инструменты",
          icon: "tools",
          permissions: ["admin"]
        },
        {
          to: { name: "settings" },
          label: "Настройки",
          icon: "tune",
          permissions: ["admin"]
        }
      ],
      "Информация",
      [
        {
          href: "https://wiki.rusbiomix.ru/",
          target: "_blank",
          label: "База знаний",
          icon: "wikipedia"
        }
      ]
    ];
    return _menu
      .map((item: any) => {
        const _type = typeof item;
        if ((_type as string) === "object") {
          item = item.map((child_item: any) => {
            if (child_item.permissions) {
              child_item =
                child_item.permissions
                  .filter((role: string) => this.actor.roles.includes(role))
                  .filter((i: any) => i).length > 0
                  ? child_item
                  : null;
              if (child_item && child_item.props) {
                child_item.props[0] = child_item.props[0]
                  .map((prop: any) => {
                    return !prop.permissions ||
                      prop.permissions
                        .filter((role: string) =>
                          this.actor.roles.includes(role)
                        )
                        .filter((i: any) => i).length > 0
                      ? prop
                      : null;
                  })
                  .filter((i: any) => {
                    return i;
                  });
              }
            }
            return child_item;
          });
          if (item.length == 0) {
            item = null;
          } else {
            item = item.filter((i: any) => {
              return i;
            });
          }
        }
        return item;
      })
      .filter((i: any) => {
        return i;
      });
  }

  created() {
    // noop
  }

  pipelines: any = [];

  mounted() {
    this.loadPipelines();

    this.$store.subscribe((mutation: any, state: any) => {
      switch (mutation.type) {
        case "ubic/SET_IDENTITY": {
          this.loadPipelines();
          break;
        }
      }
    });
  }

  deliverySheetBadge(cb: any) {
    cb(1);
  }

  loadPipelines() {
    if (!this.isAuthenticated) {
      return;
    }

    (this as any)
      .$db([
        (this as any)
          .$q("QNAME")
          .select()
          .fileds({
            id: `pipelines.id`,
            label: `pipelines.name`
          })
          .from("pipelines")
          .limit(1000)
      ])
      .then((result: ServerResult) => {
        this.pipelines = result.getOperation("QNAME").getContent().documents;
      });
  }
}
